/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { SubaccountActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        subaccounts: state.subaccounts
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getSubaccounts: (type) => {
            dispatch(SubaccountActions.fetchSubaccounts(type));
        },
        getSubaccount: (id) => {
            dispatch(SubaccountActions.fetchSubaccount(id));
        },
        updateSubaccount: (subaccount) => {
            dispatch(SubaccountActions.updateSubaccount(subaccount));
        },
        deleteSubaccount: (id) => {
            dispatch(SubaccountActions.deleteSubaccount(id));
        },
        createSubaccount: (subaccount) => {
            dispatch(SubaccountActions.createSubaccount(subaccount));
        },
        detachSubaccount: (id) => {
            dispatch(SubaccountActions.detachSubaccount(id));
        }
	};
}

export default function SubaccountProvider(Component) {

    class SubaccountProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    SubaccountProvider.displayName = "SubaccountProvider";

    return connect(mapStateToProps, mapDispatchToProps)(SubaccountProvider);
};
